import * as React from 'react';
import { BaseBulletPointPluginProps } from '../../BulletPointPlugin.types';

interface ListItemElementProps extends BaseBulletPointPluginProps {}

export const ListItemElement = ({ children }: ListItemElementProps) => {
  return <li>{children}</li>;
};
